/**
 * Message reducer for managing chat messages state
 */
const messageReducer = (state, action) => {
    switch (action.type) {
        case 'reset':
            return [ { author: "assistant", content: action.t("welcome") } ];
        case 'add':
            return [...state, action.message];
        case 'changeLast':
            return [
                ...state.slice(0, -1),
                { ...state[state.length - 1], content: action.content }
            ];
        case 'appendLast':
            {
                const last = state[state.length - 1];
                const wasThinking = last.content.startsWith("_") && last.content.endsWith("_")
                return [
                    ...state.slice(0, -1),
                    wasThinking ?
                        { ...last, content: action.delta, scroll: 300 }
                        :
                        { ...last, content: last.content + action.delta }
                ];
            }
        case 'increaseScroll':
            const last = state[state.length - 1];
            return [
                ...state.slice(0, -1),
                { ...last, scroll: last.scroll + action.scroll }
            ]
        default:
            return state;
    }
};

export default messageReducer;
